export default "__VITE_ASSET__d26d862f__"